<template>
  <div class="weight-overview">

    <div
        v-if="weights && weights.length > 0"
        class="weight"
        v-for="weight in weights"
    >
      <div class="info">
        <h5 class="weight-moment">{{ weight.weight }} kg</h5>
        <span class="date light">{{ formatDate(weight.created_at) }}</span>
      </div>

      <span
          v-if='openMenu !== -1'
          class='option-overlay'
          @click='openMenu = -1'
      ></span>

      <div
          class='options'
          @click='menuController(weight)'
          :ref='weight.id'
      >      </div>
    </div>

    <div
        :class='{visible: openMenu !== -1}'
        class='option-menu'
        ref='menu'
    >
      <span
          @click='removeWeight(openMenu.id)'
          class='delete'
      >
        Verwijder
      </span>
    </div>
  </div>
</template>

<script>

import {longDate, shortDate, shortDateWritten} from "../../../utils/filters.js";
import {mapActions} from "vuex";

export default {
  name: "WeightOverview",
  props: [
    "weights",
  ],
  data() {
    return {
      openMenu: -1,
    }
  },
  methods: {
    ...mapActions("weight", [
      "deleteWeight",
    ]),
    removeWeight(id) {
      this.deleteWeight(id).then(() => {
        this.$emit("updated");

        this.openMenu = -1;
      });
    },
    menuController(localWeight) {
      this.openMenu = localWeight;
      let optionsRef = this.$refs[localWeight.id][0];
      let menuRef = this.$refs.menu;

      menuRef.style.left = optionsRef.offsetLeft + "px";
      menuRef.style.top = optionsRef.offsetTop + "px";
    },
    formatDate(date) {
      return shortDateWritten(date); // Use the imported function here
    }
  },
};
</script>
